<div class="container">
    <h2>
        Dashboard
    </h2>
    <form [formGroup]="form" class="inputs">

        <div class="date-field">
            <label>Date From</label>
            <owc-datepicker 
                size="medium" 
                format ="dd-MMM-yyyy"
                variant="outlined" 
                placeholder="DD/MM/YYYY"
                [formControl]="dateFrom">
            </owc-datepicker>
        </div>

        <div class="date-field">
            <label>Date To</label>
            <owc-datepicker 
                size="medium" 
              format ="dd-MMM-yyyy" 
                variant="outlined" 
                placeholder="DD/MM/YYYY"
                [formControl]="dateTo">
            </owc-datepicker>
        </div>

        <div class="input-field" style="margin-top: 25px;">
            <owc-input 
                label="Notification" 
                variant="outlined"
                placeholder="Enter notification"
                [formControl]="notification">
            </owc-input>
        </div>

        <div class="input-field" style="margin-top: 25px;">
            <owc-input 
                label="Account" 
                variant="outlined"
                placeholder="Enter account"
                [formControl]="account">
            </owc-input>
        </div>

        <div class="select-field">
            <label>Type</label>
            <owc-select-dropdown 
                formControlName="type" 
                variant="outlined"
                multiple
                (visibleChange)="onTypeChange()">
                <owc-list-item *ngFor="let type of types" [value]="type" [disabled]="isTypeDisabled(type)">
                    {{ type }}
                </owc-list-item>
            </owc-select-dropdown>
        </div>

        <div class="select-field">
            <label>Account Status</label>
            <owc-select-dropdown 
                formControlName="accountStatus" 
                variant="outlined"
                multiple
                (visibleChange)="onStatusChange()">
                <owc-list-item *ngFor="let status of accountStatuses" [value]="status" [disabled]="isStatusDisabled(status)">
                    {{ status }}
                </owc-list-item>
            </owc-select-dropdown>
        </div>

        <div class="select-field">
            <label>Country</label>
            <owc-select-dropdown 
                formControlName="country" 
                variant="outlined"
                multiple
                (visibleChange)="onCountryChange()">
                <owc-list-item *ngFor="let country of countries" [value]="country" [disabled]="isCountryDisabled(country)">
                    {{ country }}
                </owc-list-item>
            </owc-select-dropdown>
        </div>
        
        <div class="error-message" *ngIf="form.hasError('dateRangeInvalid') && (form.get('dateFrom')?.touched || form.get('dateTo')?.touched)">
            'Date From' must be before or equal to 'Date To'
        </div>

    </form>

    <!-- Buttons -->
    <section class="buttons">
        <owc-button color="primary" [disabled]="form.invalid" (click)="search()">
            Search
        </owc-button>

        <owc-button color="primary" [disabled]="form.invalid" (click)="onDownload()">
            Download
        </owc-button>
    </section>

     <owc-modal-dialog [(ngModel)]="downloadVisible">
        <dl-file-format-dialog (formatSelected)="onFormatSelected($event)"></dl-file-format-dialog>
      </owc-modal-dialog>

    <!-- Chart -->
    <section class="chart-container">
        <!-- Donut Charts Row -->
        <div class="donut-charts-row">
            <!-- Notification Type Chart -->
            <div class="chart-card">
                <h3>Notification type</h3>
                <div class="chart-wrapper">
                    <canvas #notificationTypeChart></canvas>
                    <div class="chart-center-value">{{ notificationTypeData.total }}</div>
                </div>
                <div class="chart-legend">
                    <div class="legend-item" *ngFor="let item of notificationTypeData.legend">
                        <span class="legend-color" [style.background-color]="item.color"></span>
                        <span>{{ item.label }} ({{ item.count }})</span>
                    </div>
                </div>
            </div>

            <!-- Account Status Chart -->
            <div class="chart-card">
                <h3>Account status</h3>
                <div class="chart-wrapper">
                    <canvas #accountStatusChart></canvas>
                    <div class="chart-center-value">{{ accountStatusData.total }}</div>
                </div>
                <div class="chart-legend">
                    <div class="legend-item" *ngFor="let item of accountStatusData.legend">
                        <span class="legend-color" [style.background-color]="item.color"></span>
                        <span>{{ item.label }} ({{ item.count }})</span>
                    </div>
                </div>
            </div>

            <!-- Account Delivery Chart -->
            <div class="chart-card">
                <h3>Account delivery</h3>
                <div class="chart-wrapper">
                    <canvas #accountDeliveryChart></canvas>
                    <div class="chart-center-value">{{ accountDeliveryData.total }}</div>
                </div>
                <div class="chart-legend">
                    <div class="legend-item" *ngFor="let item of accountDeliveryData.legend">
                        <span class="legend-color" [style.background-color]="item.color"></span>
                        <span>{{ item.label }} ({{ item.count }})</span>
                    </div>
                </div>
            </div>

            <!-- Account Feedback Chart -->
            <div class="chart-card">
                <h3>Account feedback</h3>
                <div class="chart-wrapper">
                    <canvas #accountFeedbackChart></canvas>
                    <div class="chart-center-value">{{ accountFeedbackData.total }}</div>
                </div>
                <div class="chart-legend">
                    <div class="legend-item" *ngFor="let item of accountFeedbackData.legend">
                        <span class="legend-color" [style.background-color]="item.color"></span>
                        <span>{{ item.label }} ({{ item.count }})</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Bar Chart -->
        <div class="bar-chart-container">
            <h3>Notifications by month</h3>

            <div class="bar-chart-wrapper">
                <canvas #monthlyChart></canvas>
            </div>
        </div>
    </section>

    <!-- Table -->
    <section>
        <dl-dashboard-table [dbTableData]="dbTableData"></dl-dashboard-table>
    </section>
</div>